import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Component({
	selector: 'fb-skeleton-product-item',
	templateUrl: './skeleton-product-item.component.html',
	styleUrls: [
		'./skeleton-product-item.component.scss',
		'../product-item/product-item.component.scss'
	]
})
export class SkeletonProductItemComponent implements OnInit {

	public isMobile: boolean = false;
	public isBrowser: boolean = false;
	constructor(
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	ngOnInit(): void {
		if (this.isBrowser) {

			this.isMobile = window.innerWidth < 999;
		}
	}
}
